import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ImageDisplayComponent } from '../../../../modals/image-display/image-display.component';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class TableComponent implements OnInit, AfterViewInit {
  @Input('data') dataColumn;
  @Input('column') nameColumn;
  displayedColumns: any = [];
  displayDataSources: any;

 
  containImage: boolean = false;
  @ViewChild(MatPaginator) paginator
  @ViewChild(MatSort) sort
  constructor(public _ref: ChangeDetectorRef, public dialog: MatDialog, private _ngZone: NgZone) {





    this.displayDataSources = new MatTableDataSource<any>();

    let tmpImg: boolean = false;

  }

  ngOnInit(): void {
    
    this.displayedColumns = this.nameColumn;
    console.log(this.displayedColumns)

/*
    this.dataColumn.forEach(item => {
      console.log(item)
    })*/

  }

  isoDate(dateStr: string): Date {
    // Check if format contains french month (text)
    const hasFrenchMonth = /janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre/gi.test(dateStr);

    if (hasFrenchMonth) {
      // Convert "mardi 22 avril 2025 à 11:14" to Date
      const months: Record<string, number> = {
        janvier: 0, février: 1, mars: 2, avril: 3, mai: 4, juin: 5,
        juillet: 6, août: 7, septembre: 8, octobre: 9, novembre: 10, décembre: 11
      };

      const cleaned = dateStr
        .replace(/^\w+\s/, "")       // remove weekday "mardi "
        .replace(" à ", " ");        // replace " à " with space

      const [day, monthStr, year, time] = cleaned.split(" ");
      const [hour, minute] = time.split(":");

      return new Date(
        Number(year),
        months[monthStr.toLowerCase()],
        Number(day),
        Number(hour),
        Number(minute)
      );
    }

    // fallback for original dd/mm/yyyy hh:mm format
    const [day, month, yearAndTime] = dateStr.split('/');
    const [year, time] = yearAndTime.split(' ');
    const isoDateStr = `${year}-${month}-${day}T${time}`;

    return new Date(isoDateStr);
  }

  ngAfterViewInit(): void{
      this.displayDataSources.sort = this.sort;
      this.displayDataSources.paginator = this.paginator;



    this.dataColumn = this.dataColumn.sort((a, b) => {


      console.log(new Date(a['Date']) > new Date(b['Date']), new Date(a['Date']), `-${a['Date']}-`, new Date(b['Date']), `-${b['Date']}-`)
      if (this.isoDate(a['Date']) < this.isoDate(b['Date']))
        return 1;
      else
        return -1;
    })


    this.displayDataSources.data = this.dataColumn;
    this._ref.detectChanges();

  }

  applyFilter(filterValue: string) {


    if (filterValue.length > 0) {
      this.displayDataSources.filter = filterValue.trim().toLowerCase();
      if (this.displayDataSources.paginator) {
        this.displayDataSources.paginator.firstPage();

      }
    }
    else {
      this.displayDataSources.filter = '';
    }

    this._ref.detectChanges();
  }







}

